<template>
  <div class="bg-white shadow px-10 py-4 w-full z-10">
    <div class="flex justify-end items-center text-gray-600 space-x-1">
      <span>Welcome,</span>
      <span class="font-semibold">{{ username }}!</span>
      <img
        @click="$emit('toggleDropdown')"
        src="@/assets/images/papsi_down.svg"
        alt="Dropdown Icon"
        class="w-10 h-10 bg-white rounded-full cursor-pointer hover:bg-gray-50 p-2"
      />
    </div>
  </div>
</template>


<script>
export default {
  name: "HeaderView",
  computed: {
    username() {
      return this.$store.state.credentials.username;
    }
  },
  methods: {
    toggleDropdown() {
      this.$emit('toggleDropdown');
    }
  }
}
</script>
